"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bounceAnimation = void 0;
var styled_components_1 = require("styled-components");
exports.bounceAnimation = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0%, 100% {\n      transform: scale(0.0);\n    } 50% {\n      transform: scale(1.0);\n    }\n"], ["\n    0%, 100% {\n      transform: scale(0.0);\n    } 50% {\n      transform: scale(1.0);\n    }\n"])));
var templateObject_1;
//# sourceMappingURL=animations.js.map